var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BlockUI',{staticClass:"line"},[_c('div',{staticClass:"new-loading"},[_c('span'),_c('span'),_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }